module.exports = __webpack_public_path__ + "img/ico-pdf-empty.73234115.svg";